import React from "react";

interface KycStatusCircleIconProps {
  className?: string;
}

const KycStatusCircleIcon = ({ className }: KycStatusCircleIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={className || "w-6 h-6"}
    >
      <circle
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        cx={16}
        cy={16}
        r={12}
      />
      <rect x={15} y={14} width={2} height={8} fill="currentColor" />
      <rect x={15} y={10} width={2} height={2} fill="currentColor" />
    </svg>
  );
};

export default KycStatusCircleIcon;
